<template>
  <v-row
    no-gutterse
    class="pagination pt-5 px-2"
  >
    <v-col
      cols="12"
      lg="2"
      sm="4"
      class="pa-2"
    >
      <v-select
        v-model="size"
        class="number-per-page"
        label="Nombre par page"
        :items="[10,20,30,50,100]"
        variant="solo"
        @update:model-value="updateSize($event)"
      />
    </v-col>
    <v-col
      cols="12"
      sm="8"
      class="pa-2"
    >
      <v-skeleton-loader
        v-if="loading"
        type="subtitle"
      />
      <v-pagination
        v-else
        v-model="currentPage"
        :length="lastPage"
        :total-visible="$vuetify.display.mobile ? '2' : '6'"
        active-color="primary"
        @update:model-value="updatePagination($event)"
      />
    </v-col>
    <v-col
      cols="12"
      lg="2"
      class="pa-2"
    >
      <div
        v-if="total"
        class="pt-4 text-center"
      >
        {{ total }} éléments
      </div>
    </v-col>
  </v-row>
</template>
<script lang="ts">
export default {
    // TO DO : NEED TO KNOW TOTAL ITEMS TO SET PAGINATION LENGTH
    name : "PaginationComponent",
    props: {
        loading: { type: Boolean },
        lastPage : { type: Number, required : true },
        total : { type: Number, required : false, default : 0 },
    },
emits: ['loadData'],
    data () {
        return {
            currentPage : 1,
            size : this.$config.public.pagination_default_number || 30,
        }
    },
    computed : {
        query () {
            // return `page[number]=${this.currentPage}&page[size]=${this.size}`
            return { number : this.currentPage, size : this.size}
        }
    },
    methods : {
        getQuery() {
          return { number : this.currentPage, size : this.size}
        },
        resetPagination () {
            this.currentPage = 1
        },
        updatePagination (page) {
            this.currentPage = page
            this.$emit('loadData')
        },
        updateSize (size) {
            this.size = size
            this.resetPagination()
            this.$emit('loadData')
        },
    },
}
</script>
